
export default {
    name: 'IconPreorder',
    props: {
        width: {
            type: String,
            default: '22.500px'
        },
        height: {
            type: String,
            default: '22.723px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
